import { useState } from "react";

import { ChevronDown, ChevronUp } from "lucide-react";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "twyne-new.ui";

import Item from "./Item";

export default function Version({ group, versions, preview, ...props }) {
  const [isOpen, setIsOpen] = useState(true)

  return <Collapsible className="flex flex-col text-sm cursor-pointer" open={isOpen} onOpenChange={setIsOpen}>
    <CollapsibleTrigger className="twy-bg-base-accent" asChild>
      <div className="flex items-center justify-between px-3 pt-1 sticky -top-2">
        <h4>{group}</h4>
        { isOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} /> }
      </div>
    </CollapsibleTrigger>
    <CollapsibleContent className="m-0 pl-2 border-b-0">
      {versions.map(version => <Item key={version.id} version={version} isPreview={preview?.id === version.id} {...props} />)}
    </CollapsibleContent>
  </Collapsible>
}
